export const NETWORK_ERROR = {
  401: 'Tài khoản chưa xác thực'
}
